import React from 'react';
import { AvatarColors } from 'types/profile';
import { ChakraAvatar } from 'app/components/Core';
import { AvatarProps } from '@chakra-ui/react';

interface ListItemAvatarProps extends AvatarProps {
  src?: string;
  initials?: string;
  guid?: string;
  colors?: AvatarColors;
}

export const ListItemAvatar: React.FC<ListItemAvatarProps> = ({
  src,
  initials,
  guid,
  colors,
  ...rest
}) => (
  <ChakraAvatar
    width="40px"
    height="40px"
    src={src}
    initials={initials}
    guid={guid}
    colors={colors}
    {...rest}
  />
);
